import script from "./indicator.vue?vue&type=script&setup=true&lang=js"
export * from "./indicator.vue?vue&type=script&setup=true&lang=js"

import "./indicator.vue?vue&type=style&index=0&id=36b03e6c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b03e6c"]])

export default __exports__